import getSession from './getSession';
const modifySession = (data, key) => {

    const sessionData = getSession('sessionData');
    if (sessionData) {
        if (key) {
            sessionData[key] = data;
        }else{
            sessionData.userBalance = data;
        }
        localStorage.setItem('sessionData', JSON.stringify(sessionData));
        return true;
    } else {
        return false;
    }
};


export default modifySession;
